













































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

interface MenuItem {
    title: string;
    icon?: string;
    action?: string;
    link?: string;
    items?: MenuItem[];
}

@Component({ components: {} })
export default class WxDrawer extends Vue {
    @Prop() public value!: boolean;
    @Prop(Array) private allowedRoutes!: string[];
    @Prop(Array) private storeMenu!: any[];
    @Prop({ default: false }) private readonly noHover!: boolean;

    private menu: MenuItem[] = [];

    private xIsMiniVariant = true;
    private justMinified = false;

    constructor() {
        super();
    }

    private created() {
        this.menuBuilder();
    }

    private get isMiniVariant() {
        return this.xIsMiniVariant;
    }

    private set isMiniVariant(value: boolean) {
        this.xIsMiniVariant = value;
    }

    private get menuGroupItems() {
        const menuGroupItems: MenuItem[] = [];
        this.menu.forEach((value) => {
            if (value.items) {
                menuGroupItems.push(value);
            }
        });
        return menuGroupItems;
    }

    private get menuLinkItems() {
        const menuLinkItems: MenuItem[] = [];
        this.menu.forEach((value) => {
            if (value.link) {
                menuLinkItems.push(value);
            }
        });
        return menuLinkItems;
    }

    @Watch('allowedRoutes', { deep: true })
    private menuBuilder() {
        const someAllowedRoutes = this.allowedRoutes;
        function iterateMenu(aMenu: MenuItem[]): MenuItem[] {
            const resultingMenuItems: MenuItem[] = [];
            let aMenuItem: MenuItem;

            aMenu.forEach((menuItem) => {
                aMenuItem = { title: '' };

                if (menuItem.items) {
                    aMenuItem.items = iterateMenu(menuItem.items);
                    if (aMenuItem.items.length === 0) return resultingMenuItems;
                }

                if (!menuItem.link || someAllowedRoutes.includes(menuItem.link || '')) {
                    aMenuItem.title = menuItem.title;
                    aMenuItem.icon = menuItem.icon;
                    aMenuItem.action = menuItem.action;
                    aMenuItem.link = menuItem.link;
                    resultingMenuItems.push(aMenuItem);
                }

                return resultingMenuItems;
            });

            return resultingMenuItems;
        }
        this.menu = iterateMenu(this.storeMenu);
    }

    public deMinify() {
        if (!this.noHover && !this.justMinified) {
            this.xIsMiniVariant = false;
        } else {
            if (this.xIsMiniVariant) {
                this.xIsMiniVariant = !this.xIsMiniVariant;
            }
        }
    }

    public minify() {
        this.justMinified = true;
        this.xIsMiniVariant = true;
        setTimeout(() => {
            this.justMinified = false;
        }, 300);
    }

    public changeMinify() {
        this.xIsMiniVariant = !this.xIsMiniVariant;
    }
}
